import { gql } from '@apollo/client';

export const GET_CSV_UPLOAD_URL = gql`
  mutation GetCsvUploadUrl($filename: String!) {
    getCsvUploadUrl(filename: $filename) {
      key
      url
      fields
    }
  }
`;

export const IMPORT_CSV = gql`
  mutation ImportCsv($key: String!) {
    importCsv(key: $key) {
      jobId
    }
  }
`;
